import { DENIED_ROUTE_FALLBACK } from '@vrplatform/data';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

/**
 * Wrap a route element in its permission gate.
 *
 * The path stays registered so a deep link or a bookmark kept from a previous
 * role still matches and lands somewhere useful, instead of falling through to
 * whichever catch-all happens to be in scope. Denied users go to the
 * dashboard, which is never permission-gated.
 *
 * Navigation items gate on the same `ROUTE_PERMISSIONS` key, so a visible link
 * can never point at a route that redirects away.
 */
export const gatedRouteElement = (
  canAccess: boolean,
  element: ReactNode
): ReactNode =>
  canAccess ? element : <Navigate to={DENIED_ROUTE_FALLBACK} replace />;
